import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from "src/provider/API/call-service"
import { BsThreeDotsVertical } from "react-icons/bs"
import { Dropdown, Filter, Portal, ServerSideTable } from "src/component"
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, FormGroupWithIcon } from "src/style"
import BankinglyIcon from 'src/assets/img/bankingly-icon.png'
import EbanqoIcon from 'src/assets/img/ebanqo-icon.png'
import QoreidIcon from 'src/assets/img/qoreid-icon.png'
import { FiChevronDown } from "react-icons/fi"
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io"
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { CreateNewServiceProvider } from "src/popup"
import { serviceProvidersColumns, serviceProvidersData } from "src/utils/table-layout"
import helpers from "src/utils/helpers"
import utility from "src/utils/utility"

export const ServiceProviders = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [view, setView] = useState('')

    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = await API.getServiceProviders({
            pageNumber, pageSize, 
            sortColumn: 'id', 
            sortOrder: 'desc',
            ...filterDataRef.current, 
            //returnMax: isDownload
        })

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'SERVICE_PROVIDERS_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    async function handleProviderAction (provider: any, value: string) {
        if (['deactivate', 'activate'].includes(value)) {
            decisionBox.show(
                `Are you sure you want to ${value} this service provider?`,
                () => handleProviderActivationAndDeactivation(value, provider.id),
                decisionBox.hide,
                `Yes, ${utility.toTitleCase(value)}`,
                'No'
            )
        }
        else if (value === 'view') {
            await setInfoProperty('selectedServiceProvider', provider)
            navigate(`/admin/administration/service-provider/${provider.id}`)
        }
    }

    async function handleProviderActivationAndDeactivation (type: string, id: string) {
        const response = type === 'activate' ? 
            await API.activateServiceProvider(id)
            : await API.deactivateServiceProvider(id)
        
        if (response) handleFetchReport()
        decisionBox.hide()
    }

    return (
        <>
            <CustomContainer>
                <FlexRow 
                    justifyContent='space-between' alignItems='flex-start' 
                    bottomMargin='1.5' gap='1.5' wrap='wrap'
                >
                    <AppText textSize='2' color='#101828' fontWeight="500">
                        Service Providers
                    </AppText>
                    <Button
                        width='21' fontWeight="500"
                        height='4' radius='0.8' hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={() => setView('create-service-provider')}
                    >
                        Add New Service Provider
                    </Button>
                </FlexRow>
                <ServerSideTable
                    tableData={report}
                    tableColumns={serviceProvidersColumns(handleProviderAction)} 
                    dataFetchMethod={handleFetchReport}
                    totalRows={reportData?.totalRecords}
                    customStyle
                    shouldResetPagination={resetPagination}
                    canFilter={() => setView('filter')}
                    canClear={handleClear}
                    downloadAction={() => handleFetchReport(1, 10, true)}
                />
            </CustomContainer>
            { view === 'filter' &&
                <Portal>
                    <Filter
                        type='service-providers'
                        onApplyFilter={handleFetchReport}
                        setFilterData={(data: any) => {filterDataRef.current = data}}
                        close={() => setView('')}
                    />
                </Portal>
            }
            { view === 'create-service-provider' &&
                <CreateNewServiceProvider
                    getProviders={handleFetchReport} 
                    close={() => setView('')}
                />
            }
            {/* <CustomContainer
                 className="services-dropdown-container"
                 bottomMargin="2"
            >
                <FormGroupWithIcon 
                >
                    <label>Service</label>
                    <div className="input-with-icon" style={{height: '4rem'}}>
                        <select 
                            name='role'
                            value={selectedService}
                            style={{color: selectedService ? '#000000' : '#667085'}}
                            onChange={(e) => setSelectedService(e.target.value)}
                            autoComplete="off"
                        >
                            {
                                services?.map((service, index) => {
                                    return (
                                        <option value={service.label} key={index}>{service.label}</option>
                                    )
                                })
                            }
                        </select>
                        <FiChevronDown className="input-with-icon-tag" />
                    </div>
                </FormGroupWithIcon>
            </CustomContainer>
            <FlexRow 
                justifyContent="space-between" 
                alignItems="flex-start" 
                gap="8" topMargin="3"
            >
                <CustomContainer
                    width="25"
                    className="service-types-container"
                >
                    {
                        services.map((service, index) => {
                            return (
                                <CustomContainer
                                    padding="1" radius="0.6"
                                    topPadding="0.6" bottomPadding="0.6"
                                    bgColor={selectedService === service.label ? '#E7F6F5' : 'transparent'}
                                    key={index}
                                    onClick={() => setSelectedService(service.label)}
                                >
                                    <AppSpan
                                        color={selectedService === service.label ? '#0A756F' : '#667085'}
                                        fontWeight="500"
                                        cursor="pointer"
                                    >
                                        {service.label}
                                    </AppSpan>
                                </CustomContainer>
                            )
                        })
                    }
                </CustomContainer>
                
                <CustomContainer>
                    <FlexRow
                        justifyContent="space-between"
                        alignItems="center"
                        gap="2.5" wrap="wrap"
                    >
                        <CustomContainer width="auto" sizeUnit="">
                            <AppText 
                                color="#101828" textSize="1.8" fontWeight="500"
                            >
                                {selectedService}
                            </AppText>
                            <AppSpan>Modify your workflow and connect and disconnect product and categories</AppSpan>
                        </CustomContainer>
                        <Button
                            width='22.4'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                            onClick={() => setView('create-service-provider')}
                        >
                            Create new Service Provider
                        </Button>
                    </FlexRow>
                    <CustomContainer topMargin="3">
                       {
                            providers?.map((provider, index) => {
                                return (
                                    <CustomContainer 
                                        padding="1.5"
                                        key={index}
                                        className="tab-container"
                                    >
                                        <FlexRow 
                                            justifyContent="space-between"
                                            gap="2"
                                        >
                                            <FlexRow gap="2" width="auto" sizeUnit="">
                                                <CustomContainer 
                                                    width="3.9" height="4.7"
                                                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                >
                                                    <img src={provider.icon} className='img-covered' style={{objectFit: 'contain'}} />
                                                </CustomContainer>
                                                <CustomContainer width="auto" sizeUnit="">
                                                    <AppText color="#344054" fontWeight="500">{provider.name}</AppText>
                                                    <AppSpan>{provider.description}</AppSpan>
                                                </CustomContainer>
                                            </FlexRow>
                                            <Dropdown 
                                                trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#0A756F' />}
                                                options={[
                                                    {value: 'view', label: 'View Details'},
                                                    {value: 'deactivate', label: 'Deactivate Service Provider'}
                                                ]}
                                                onSelect={(value: string) => handleProviderAction(provider, value)}
                                                width={23}
                                            />
                                        </FlexRow>
                                    </CustomContainer>
                                )
                            })
                       }

                       <FlexRow 
                            justifyContent="space-between"
                            gap="2" topMargin="3"
                       >
                            <Button
                                width='12'
                                titleSize='1.4' fontWeight="500"
                                height='4' radius='0.8' color="#667085"
                                bgColor="transparent"
                                hoverBgColor='#fff' hoverBorderColor='#0D968F'
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                            >
                                <AppSpan rightMargin="1" textSize="1.6"><IoMdArrowBack /></AppSpan>
                                Previous
                            </Button>
                            <FlexRow 
                                width="auto" sizeUnit=""
                                gap="0.2" wrap="wrap"
                                className="pagination-numbers-container"
                            >
                                {
                                    [1, 2, 3].map((item, index) => {
                                        return (
                                            <Circle
                                                size="4" key={index}
                                                bgColor={pageNumber === item ? '#0D968F' : 'transparent'}
                                                onClick={() => setPageNumber(item)}
                                            >
                                                <AppSpan
                                                    fontWeight="500" cursor="pointer"
                                                    color={pageNumber === item ? '#ffffff' : '#667085'}
                                                >
                                                    {item}
                                                </AppSpan>
                                            </Circle>
                                        )
                                    })
                                }
                                <Circle size="4">
                                    <HiOutlineDotsHorizontal fill="#667085" />
                                </Circle>
                                {
                                    [8, 9, 10].map((item, index) => {
                                        return (
                                            <Circle
                                                size="4" key={index}
                                                bgColor={pageNumber === item ? '#0D968F' : 'transparent'}
                                                onClick={() => setPageNumber(item)}
                                            >
                                                <AppSpan
                                                    fontWeight="500" cursor="pointer"
                                                    color={pageNumber === item ? '#ffffff' : '#667085'}
                                                >
                                                    {item}
                                                </AppSpan>
                                            </Circle>
                                        )
                                    })
                                }
                            </FlexRow>
                            <Button
                                width='12'
                                titleSize='1.4' fontWeight="500"
                                height='4' radius='0.8' color="#667085"
                                bgColor="transparent"
                                hoverBgColor='#fff' hoverBorderColor='#0D968F'
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                            >
                                Next
                                <AppSpan leftMargin="1" textSize="1.6"><IoMdArrowForward /></AppSpan>
                            </Button>
                       </FlexRow>
                    </CustomContainer>
                </CustomContainer>
            </FlexRow> */}
        </>
    )
}


// const services = [
//     {
//         label: 'Platform & Admin'
//     },
//     {
//         label: 'Chat bot'
//     },
//     {
//         label: 'ID verification'
//     },
//     {
//         label: 'Loan insurance'
//     },
//     {
//         label: 'End customer insurance'
//     },
//     {
//         label: 'Corporate internet banking'
//     }
// ]

// const providers = [
//     {
//         name: 'Bankingly',
//         id: 980220,
//         website: 'https://google.com',
//         feeSettlementAccount: '9802351829',
//         adminFirstName: 'John',
//         adminLastName: 'Doe',
//         adminEmail: 'example@gmail.com',
//         adminPhoneNumber: '07036172919',
//         icon: BankinglyIcon,
//         description: 'Bankingly helps financial institutions provide electronic channels to their customers'
//     },
//     {
//         name: 'eBanqo',
//         id: 980220,
//         website: 'https://google.com',
//         feeSettlementAccount: '9802351829',
//         adminFirstName: 'John',
//         adminLastName: 'Doe',
//         adminEmail: 'example@gmail.com',
//         adminPhoneNumber: '07036172919',
//         icon: EbanqoIcon,
//         description: 'eBanqo is an omnichannel customer engagement platform that helps businesses to automate customer support'
//     },
//     {
//         name: 'QoreID',
//         id: 980220,
//         website: 'https://google.com',
//         feeSettlementAccount: '9802351829',
//         adminFirstName: 'John',
//         adminLastName: 'Doe',
//         adminEmail: 'example@gmail.com',
//         adminPhoneNumber: '07036172919',
//         icon: QoreidIcon,
//         description: 'QoreID provides a full suite of trust products customized to securely meet your identity and compliance needs.'
//     },
//     {
//         name: 'eBanqo',
//         id: 980220,
//         website: 'https://google.com',
//         feeSettlementAccount: '9802351829',
//         adminFirstName: 'John',
//         adminLastName: 'Doe',
//         adminEmail: 'example@gmail.com',
//         adminPhoneNumber: '07036172919',
//         icon: EbanqoIcon,
//         description: 'eBanqo is an omnichannel customer engagement platform that helps businesses to automate customer support'
//     },
//     {
//         name: 'QoreID',
//         id: 980220,
//         website: 'https://google.com',
//         feeSettlementAccount: '9802351829',
//         adminFirstName: 'John',
//         adminLastName: 'Doe',
//         adminEmail: 'example@gmail.com',
//         adminPhoneNumber: '07036172919',
//         icon: QoreidIcon,
//         description: 'QoreID provides a full suite of trust products customized to securely meet your identity and compliance needs.'
//     },
//     {
//         name: 'Bankingly',
//         id: 980220,
//         website: 'https://google.com',
//         feeSettlementAccount: '9802351829',
//         adminFirstName: 'John',
//         adminLastName: 'Doe',
//         adminEmail: 'example@gmail.com',
//         adminPhoneNumber: '07036172919',
//         icon: BankinglyIcon,
//         description: 'Bankingly helps financial institutions provide electronic channels to their customers'
//     },
// ]